import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import './ChatSectionFilePreview.scss';
import { Stack, Typography } from '@mui/material';
import { COLORS } from '../../../../../theme';

const ChatSectionFilePreview = ({ file, type, onClose }) => {
  const url = URL.createObjectURL(file);

  if (!type) return null;

  return (
    <div className='chat-section-file-preview-container'>
      <div className='chat-section-file-preview'>
        {(() => {
          if (type === 'file/pdf') {
            return <embed src={url} type='application/pdf' frameBorder='0' height='65px' width='50px'></embed>;
          }
          if (type === 'file/image') {
            return <img src={url} alt={file.name} className='chat-section-file-preview-image' />;
          }
          // TODO: Eventually, use variants for the Typography instead of manually styling
          if (type === 'file/csv' || type === 'file/xlsx') {
            return (
              <Stack
                direction='column'
                sx={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '65px',
                  width: '50px',
                  p: 0
                }}
              >
                <Typography
                  color={COLORS.MIDNIGHT}
                  sx={{
                    flex: 1,
                    fontSize: '11px',
                    overflow: 'hidden',
                    maxHeight: '100%',
                    width: '100%',
                    display: '-webkit-box',
                    wordWrap: 'break-word',
                    wordBreak: 'break-word',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical'
                  }}
                >
                  {file.name}
                </Typography>
                <Typography
                  size='small'
                  color={COLORS.MIDNIGHT}
                  sx={{
                    textAlign: 'center',
                    fontSize: '11px',
                    backgroundColor: COLORS.METALLICA,
                    width: '100%'
                  }}
                >
                  {type === 'file/csv' ? 'CSV' : 'XLSX'}
                </Typography>
              </Stack>
            );
          }
          return null;
        })()}
      </div>
      <FontAwesomeIcon
        icon={faCircleXmark}
        className='chat-section-file-preview-close'
        onClick={onClose}
        style={{ fontSize: 24, color: 'black', cursor: 'pointer' }}
      />
    </div>
  );
};

export default ChatSectionFilePreview;
